import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'; 
import AppRoutes from './routes/AppRoutes'; 
import { BrowserRouter, HashRouter, Route, Routes, Link  } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter> 
    <App />
    <AppRoutes /> 
</BrowserRouter>
);
 
